(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bm-featureed"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.fc-section').forEach(function (SEC) {
  'use strict';

  /* ── Size chip selection + live price update ── */
  SEC.querySelectorAll('.fc-size-chip').forEach(function (chip) {
    chip.addEventListener('click', function () {
      var group = this.closest('.fc-size-options');
      group.querySelectorAll('.fc-size-chip').forEach(function (c) { c.classList.remove('is-selected'); });
      this.classList.add('is-selected');

      var card        = this.closest('.fc-card');
      var atcBtn      = card.querySelector('.js-atc-btn');
      var variantWrap = card.querySelector('.fc-variant-wrap');
      if (!atcBtn || !variantWrap) return;

      var selectedValues = [];
      variantWrap.querySelectorAll('.fc-size-options').forEach(function (g) {
        var sel = g.querySelector('.is-selected');
        if (sel) selectedValues.push(sel.dataset.value);
      });

      var productUrl = variantWrap.dataset.productUrl;
      if (!productUrl) return;

      fetch(productUrl)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var matched = data.variants.find(function (v) {
            return selectedValues.every(function (val, idx) {
              return v['option' + (idx + 1)] === val;
            });
          });
          if (!matched) return;

          atcBtn.dataset.variantId = matched.id;

          var priceEl   = card.querySelector('.fc-price-current');
          var compareEl = card.querySelector('.fc-price-compare');
          var saveEl    = card.querySelector('.fc-price-save');

          if (priceEl)   priceEl.textContent   = formatMoney(matched.price);
          if (compareEl) compareEl.style.display = (matched.compare_at_price > matched.price) ? '' : 'none';
          if (compareEl && matched.compare_at_price > matched.price) compareEl.textContent = formatMoney(matched.compare_at_price);
          if (saveEl) {
            if (matched.compare_at_price > matched.price) {
              var pct = Math.round((matched.compare_at_price - matched.price) / matched.compare_at_price * 100);
              saveEl.textContent = pct + '% off';
              saveEl.style.display = '';
            } else {
              saveEl.style.display = 'none';
            }
          }

          var textEl = atcBtn.querySelector('.fc-atc-text');
          if (!matched.available) {
            atcBtn.disabled = true;
            atcBtn.classList.add('fc-btn-atc--soldout');
            if (textEl) textEl.textContent = 'Sold Out';
          } else {
            atcBtn.disabled = false;
            atcBtn.classList.remove('fc-btn-atc--soldout');
            if (textEl) textEl.textContent = 'Add to Cart';
          }
        })
        .catch(function () {});
    });
  });

  /* ── Add to Cart ── */
  SEC.querySelectorAll('.js-atc-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (this.disabled || this.classList.contains('is-loading')) return;
      var variantId = parseInt(this.dataset.variantId, 10);
      if (!variantId) return;

      var self    = this;
      var textEl  = self.querySelector('.fc-atc-text');
      self.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status === 422) {
            self.classList.remove('is-loading');
            if (textEl) textEl.textContent = data.description || 'Error';
            setTimeout(function () { if (textEl) textEl.textContent = 'Add to Cart'; }, 2500);
            return;
          }
          self.classList.remove('is-loading');
          self.classList.add('is-success');
          if (textEl) textEl.textContent = 'Added!';

          /* ── Open cart drawer / mini-cart (Prestige + most themes) ── */
          openCart(data);

          setTimeout(function () {
            self.classList.remove('is-success');
            if (textEl) textEl.textContent = 'Add to Cart';
          }, 2200);
        })
        .catch(function () {
          self.classList.remove('is-loading');
          if (textEl) textEl.textContent = 'Try again';
          setTimeout(function () { if (textEl) textEl.textContent = 'Add to Cart'; }, 2500);
        });
    });
  });

  /* ── Wishlist toggle ── */
  SEC.querySelectorAll('.js-wishlist-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      this.classList.toggle('is-active');
      document.dispatchEvent(new CustomEvent('fc:wishlist:toggle', { detail: { productId: this.dataset.productId } }));
    });
  });

  /* ── Helpers ── */
  function formatMoney(cents) {
    var symbol = window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'INR' ? '\u20B9' : '$';
    return symbol + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  /**
   * openCart — triggers the cart drawer/sidebar used by Prestige and other themes.
   * Covers: Prestige native event, cart-notification, cart-drawer, mini-cart,
   * and falls back to /cart page redirect if nothing responds.
   */
  function openCart(lineItem) {
    /* 1. Prestige v10+ — dispatches 'cart:open' on document */
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));

    /* 2. Prestige also listens for this on the cart icon / drawer component */
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { lineItem: lineItem } }));

    /* 3. Dawn / most Shopify themes — cart-notification & cart-drawer web components */
    var cartNotification = document.querySelector('cart-notification');
    if (cartNotification && typeof cartNotification.renderContents === 'function') {
      cartNotification.renderContents({ items: [lineItem] });
    }
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents({ items: [lineItem] });
    }

    /* 4. Trigger click on hidden cart toggle buttons many themes use */
    var cartToggles = document.querySelectorAll(
      '[data-cart-toggle], [data-drawer-toggle="cart"], .js-cart-toggle, ' +
      '.cart-toggle, [aria-controls="cart-drawer"], [data-action="open-cart"]'
    );
    cartToggles.forEach(function (el) {
      /* only click if cart is currently closed to avoid toggling closed */
      if (!document.querySelector('[id*="cart"][open], [id*="cart"].is-open, [id*="cart"].active')) {
        el.click();
      }
    });

    /* 5. Update all cart count badges */
    updateCartCount();
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Update count badges — covers Prestige, Dawn, Debut, and custom themes */
        document.querySelectorAll(
          '[data-cart-count], .cart-count, .header__cart-count, ' +
          '.cart__count, [data-header-cart-quantity], .js-cart-count, ' +
          '[data-cart-item-count]'
        ).forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.removeAttribute('hidden');
            el.closest('[data-cart-count-bubble]') && el.closest('[data-cart-count-bubble]').removeAttribute('hidden');
          }
        });
        document.dispatchEvent(new CustomEvent('fc:cart:updated', { detail: cart }));
      })
      .catch(function () {});
  }
});

  } catch(e) { console.error(e); }
})();
})();
